import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import palette from '../assets/sass/palette.scss';

const GameButton = ({ link = null, onClick = null, icon = null, text, disabled = false, backgroundColor = '', textColor = palette.secondary }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) onClick();
    if (link) navigate(link);
  };

  return (
    <Button
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      variant="outlined"
      sx={{
        borderRadius: '6px',
        borderColor: palette.borderPink,
        backgroundColor: backgroundColor,
        color: textColor ,
        mr: 1,
        fontSize: '12px',
        minWidth: '90px',
      }}
    >
      {icon && <><img src={icon} alt={`${text} icon`} /> &nbsp; </>}{text}
    </Button>
  )
}

export default GameButton;